import DepsService from 'services/dependencies';

const CONTEXT = 'manage-configurable-link';

export const fetchConfigurableLink = async (locale) => {
  const url = DepsService.rest.widgets.configurableLink.url;
  const urlParams = { };
  const queryParams = { locale };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const updateConfigurableLink = async (entries) => {
  const url = DepsService.rest.cms.configurableLink.url;
  const data = { entries };

  return DepsService.restSrv.create(CONTEXT, url, data);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/manage-configurable-link.api.js